/* eslint-disable i18next/no-literal-string -- css not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

import { radiomark } from './radiomark';

export const radioGroup = defineSlotRecipe({
  className: 'chakra-radio-group',
  slots: ['item', 'itemControl', 'label'],
  base: {
    itemControl: radiomark.base,
  },
  variants: {
    variant: {
      solid: {
        itemControl: radiomark.variants?.variant?.solid,
      },
    },

    size: {
      lg: {
        item: { textStyle: 'md', gap: '3' },
        itemControl: radiomark.variants?.size?.lg,
      },
    },
  },

  defaultVariants: {
    size: 'lg',
    variant: 'solid',
  },
});
